var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCrossedOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7744 2.93245C13.4683 2.95801 13.1544 2.97181 12.8343 2.97181C10.7017 2.97181 8.83408 2.38258 7.80079 1.5C6.7675 2.38241 4.89983 2.97181 2.76745 2.97181C2.44723 2.97181 2.13348 2.95801 1.82722 2.93245C1.74945 4.69794 1.78302 7.71069 2.78639 9.88694C4.17613 12.9014 7.79913 14.4992 7.80079 14.5C7.80245 14.4992 11.4253 12.9014 12.8152 9.88694C13.8184 7.71069 13.8521 4.69794 13.7744 2.93245ZM11.8686 9.44002C10.9259 11.4851 8.71892 12.8316 7.80079 13.3217C6.87701 12.8289 4.67533 11.4844 3.73277 9.44002C3.30586 8.51404 2.83109 6.84762 2.84439 4.02865C4.75526 4.01687 6.53851 3.56557 7.80079 2.79334C9.0629 3.56557 10.8463 4.01687 12.7572 4.02865C12.7705 6.84728 12.2957 8.51387 11.8686 9.44002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68147 4.48835C7.58227 4.38793 7.43021 4.37885 7.34214 4.46816L4.25324 7.59445C4.16517 7.68377 4.17381 7.83768 4.27335 7.93809C4.37256 8.03851 4.52444 8.04743 4.61268 7.95828L7.70142 4.832C7.78982 4.74268 7.78068 4.58877 7.68147 4.48835Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5163 6.05386L5.8198 7.77074C5.73172 7.86006 5.74036 8.0138 5.8399 8.11422C5.93894 8.21481 6.091 8.22356 6.17924 8.13441L7.87557 6.41769C7.96398 6.32821 7.95501 6.1743 7.8558 6.07405C7.75626 5.97363 7.60437 5.96454 7.5163 6.05386Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80078 13.4521L14.3027 2.11523",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCrossedOut);
export default __webpack_public_path__ + "static/media/shieldCrossedOut.b7dc3a958e20e3795d7a37d837e2b691.svg";
export { ForwardRef as ReactComponent };